import React, { useState } from "react";
import { Container, Tab } from "@mui/material";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import TabsMenu from "../../components/TabsMenu";
import { TabPanel } from "@mui/lab";
import IngestMerchantInfo from "./ingest-merchant-info";
import IngestGateway from "./ingest-gateway";
import IngestAcquirer from "./ingest-acquirer";
import MerchantDetail from "./merchant-detail";
import BusinessEntity from "./business-entity";

const PayoutIngestor = () => {
  const [selectedView, setSelectedView] = useState("Ingest gateway");

  const handleChange = (event, value) => {
    setSelectedView(value);
  };

  return (
    <Container>
      <HeaderHelpPage title="Payout Ingestor" />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="Ingest gateway" value="Ingest gateway" />
        <Tab label="Ingest acquirer" value="Ingest acquirer" />
        <Tab label="Ingest Merchant Info" value="Ingest Merchant Info" />
        <Tab label="Merchant Detail" value="Merchant Detail" />
        <Tab label="Business Entity" value="Business Entity" />
        <TabPanel value="Ingest gateway">
          <IngestGateway />
        </TabPanel>
        <TabPanel value="Ingest acquirer">
          <IngestAcquirer />
        </TabPanel>
        <TabPanel value="Ingest Merchant Info">
          <IngestMerchantInfo />
        </TabPanel>
        <TabPanel value="Merchant Detail">
          <MerchantDetail />
        </TabPanel>
        <TabPanel value="Business Entity">
          <BusinessEntity />
        </TabPanel>
      </TabsMenu>
    </Container>
  );
};

export default PayoutIngestor;
